export default {
  '--switch-track-background': '#727272',
  '--switch-handle-background': '#727272'
};